/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Apikeymanager_Button_Clear2Inputs */

const id_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapus Kunci`)
};

const ms_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kosongkan Kunci`)
};

const da_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ryd Nøgle`)
};

const de_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlüssel löschen`)
};

const en_us2_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear Key`)
};

const es_es2_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar clave`)
};

const es_mx2_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar Key`)
};

const fil_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-clear ang Key`)
};

const fr_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer la clé`)
};

const it_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancella chiave`)
};

const hu_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kulcs törlése`)
};

const nl_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sleutel wissen`)
};

const no_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fjern nøkkel`)
};

const pl_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyczyść klucz`)
};

const pt_br2_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear Key`)
};

const pt_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar chave`)
};

const ro_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Șterge cheia`)
};

const fi_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tyhjennä avain`)
};

const sv_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rensa nyckel`)
};

const vi_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xóa khóa`)
};

const tr_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anahtarı Temizle`)
};

const cs_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vymazat klíč`)
};

const bg_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изчистване на ключ`)
};

const ru_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очистить ключ`)
};

const uk_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очистити ключ`)
};

const ar_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مسح المفتاح`)
};

const hi_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`साफ़`)
};

const th_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ล้างคีย์`)
};

const ja_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キーをクリア`)
};

const zh_cn2_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear Key`)
};

const zh_hant1_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear Key`)
};

const ko_components_apikeymanager_button_clear2 = /** @type {(inputs: Components_Apikeymanager_Button_Clear2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear Key`)
};

/**
* | output |
* | --- |
* | "Clear Key" |
*
* @param {Components_Apikeymanager_Button_Clear2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_apikeymanager_button_clear2 = /** @type {((inputs?: Components_Apikeymanager_Button_Clear2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Apikeymanager_Button_Clear2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_apikeymanager_button_clear2(inputs)
	if (locale === "ms") return ms_components_apikeymanager_button_clear2(inputs)
	if (locale === "da") return da_components_apikeymanager_button_clear2(inputs)
	if (locale === "de") return de_components_apikeymanager_button_clear2(inputs)
	if (locale === "en-US") return en_us2_components_apikeymanager_button_clear2(inputs)
	if (locale === "es-ES") return es_es2_components_apikeymanager_button_clear2(inputs)
	if (locale === "es-MX") return es_mx2_components_apikeymanager_button_clear2(inputs)
	if (locale === "fil") return fil_components_apikeymanager_button_clear2(inputs)
	if (locale === "fr") return fr_components_apikeymanager_button_clear2(inputs)
	if (locale === "it") return it_components_apikeymanager_button_clear2(inputs)
	if (locale === "hu") return hu_components_apikeymanager_button_clear2(inputs)
	if (locale === "nl") return nl_components_apikeymanager_button_clear2(inputs)
	if (locale === "no") return no_components_apikeymanager_button_clear2(inputs)
	if (locale === "pl") return pl_components_apikeymanager_button_clear2(inputs)
	if (locale === "pt-BR") return pt_br2_components_apikeymanager_button_clear2(inputs)
	if (locale === "pt") return pt_components_apikeymanager_button_clear2(inputs)
	if (locale === "ro") return ro_components_apikeymanager_button_clear2(inputs)
	if (locale === "fi") return fi_components_apikeymanager_button_clear2(inputs)
	if (locale === "sv") return sv_components_apikeymanager_button_clear2(inputs)
	if (locale === "vi") return vi_components_apikeymanager_button_clear2(inputs)
	if (locale === "tr") return tr_components_apikeymanager_button_clear2(inputs)
	if (locale === "cs") return cs_components_apikeymanager_button_clear2(inputs)
	if (locale === "bg") return bg_components_apikeymanager_button_clear2(inputs)
	if (locale === "ru") return ru_components_apikeymanager_button_clear2(inputs)
	if (locale === "uk") return uk_components_apikeymanager_button_clear2(inputs)
	if (locale === "ar") return ar_components_apikeymanager_button_clear2(inputs)
	if (locale === "hi") return hi_components_apikeymanager_button_clear2(inputs)
	if (locale === "th") return th_components_apikeymanager_button_clear2(inputs)
	if (locale === "ja") return ja_components_apikeymanager_button_clear2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_apikeymanager_button_clear2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_apikeymanager_button_clear2(inputs)
	return ko_components_apikeymanager_button_clear2(inputs)
});
export { components_apikeymanager_button_clear2 as "components.apiKeyManager.button.clear" }